import useGetApi from "../../services/useGetApi";
import { useEffect } from "react";
import dayjs from "dayjs";
import { CalendarFilled } from "@ant-design/icons";
import { Button, Card, Col, Row } from "antd";

const LiveClass = ({ courseId }) => {
  const [isLoading, liveClassError, liveClass, getLiveClass] = useGetApi(
    `course/zoom-live-class/${courseId}`,
    [],
    true
  );

  useEffect(() => {
    getLiveClass(`course/zoom-live-class/${courseId}`);
  }, [courseId]);

  if (!liveClass) return null; // No live class available

  // Convert date and time into proper format
  const formattedDateTime = dayjs(
    `${liveClass.liveDate} ${liveClass.liveTime}`
  ).format("hh:mm A : ddd, DD MMM YYYY");

  // Check if the class is expired
  const isExpired = dayjs().isAfter(
    dayjs(`${liveClass.liveDate} ${liveClass.liveTime}`)
  );

  return (
    <Card title="Live Class">
      <Row>
        <Col span={24} style={{ textAlign: "center" }}>
          <p>
            <CalendarFilled /> Live Class Schedule
          </p>
          <h3>{formattedDateTime}</h3>
          <p>{liveClass.noteToStudents}</p>
          {isExpired ? (
            <Button type="default" danger disabled>
              Expired
            </Button>
          ) : (
            <Button
              type="primary"
              href={`https://zoom.us/j/${liveClass.meetingId}?pwd=${liveClass.meetingPassword}`}
              target="_blank"
            >
              Join Live Class
            </Button>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default LiveClass;
